/*
 * Public API Surface of core-services
 */

export * from './lib/core-services.service';
export * from './lib/core-services.component';
export * from './lib/core-services.module';
export * from './lib/services';
